import { useCallback } from "react";

import {
  EntitiesSupportingGroups,
  EntityTypeSupportingGroups,
  Group,
} from "@mapmycustomers/shared/types/entity";

import {
  bulkAddEntitiesToGroups,
  bulkRemoveEntitiesFromGroups,
} from "@app/component/view/SelectBar/store/actions";
import BulkGroupOperation from "@app/enum/BulkGroupOperation";

const useSubmitHandler = (
  bulkAdd: typeof bulkAddEntitiesToGroups.request,
  bulkRemove: typeof bulkRemoveEntitiesFromGroups.request,
  operation: BulkGroupOperation,
  entityType: EntityTypeSupportingGroups,
  entities: Array<EntitiesSupportingGroups>,
  groupIds: Group["id"][],
  onSuccess: () => void
) => {
  return useCallback(() => {
    switch (operation) {
      case BulkGroupOperation.ADD:
        bulkAdd({ entities, entityType, groupIds, onSuccess });
        break;

      case BulkGroupOperation.REMOVE:
        bulkRemove({ entities, entityType, groupIds, onSuccess });
        break;
    }
  }, [bulkAdd, bulkRemove, entities, groupIds, entityType, onSuccess, operation]);
};

export default useSubmitHandler;
